import styled from 'styled-components'

export const Container = styled.div`
    height: 89.7vh;
    overflow-y: hidden;
`
